import { Property } from "../models/Property";
import { a11yStandardKeys } from "./constants";

/**
 * A tab that groups the properties of a building area by their a11y standard,
 * shown between the building area tab and the tabs of the single properties.
 */
export type PropertyTabGroup = {
  // key in the translation dictionaries
  labelKey: string;
  standards: string[];
}

const DAFTO_RESORT_BUILDING_AREA = '9d46481d-19f2-462a-b075-5331288bcc53'
const MALTA_WTTC_BUILDING_AREA = '0669fe0e-9393-43a7-af95-195960ebebc5'

const DAFTO_TAB_GROUPS: PropertyTabGroup[] = [
  { labelKey: 'common_buildings', standards: [a11yStandardKeys.office] },
  { labelKey: 'hotels', standards: [a11yStandardKeys.hotel] },
  { labelKey: 'cottages', standards: [a11yStandardKeys.cottage] },
  { labelKey: 'camping', standards: [a11yStandardKeys.serviceHouse] },
  { labelKey: 'restaurant', standards: [a11yStandardKeys.restaurant] },
]

export const MALTA_HOTELS_GROUP: PropertyTabGroup = { labelKey: 'hotels', standards: [a11yStandardKeys.hotel] }
export const MALTA_VENUES_GROUP: PropertyTabGroup = {
  labelKey: 'venues',
  standards: [a11yStandardKeys.museum, a11yStandardKeys.attractionPark],
}

const MALTA_TAB_GROUPS: PropertyTabGroup[] = [MALTA_HOTELS_GROUP, MALTA_VENUES_GROUP]

const TAB_GROUPS_BY_BUILDING_AREA: Record<string, PropertyTabGroup[]> = {
  [DAFTO_RESORT_BUILDING_AREA]: DAFTO_TAB_GROUPS,
  [MALTA_WTTC_BUILDING_AREA]: MALTA_TAB_GROUPS,
}

export const isMaltaWttcBuildingArea = (buildingAreaId?: string | null): boolean => (
  buildingAreaId === MALTA_WTTC_BUILDING_AREA
)

export const getPropertyTabGroups = (
  buildingAreaId?: string | null,
  properties?: Property[]
): PropertyTabGroup[] => {
  const groups = buildingAreaId ? TAB_GROUPS_BY_BUILDING_AREA[buildingAreaId] : undefined
  if (groups) {
    return groups
  }
  // Daftö copies on other environments have their own ids, so keep the standard it is recognised by
  const isCottage = !!properties && properties.some((i) => i.a11y_standard === a11yStandardKeys.cottage)
  return isCottage ? DAFTO_TAB_GROUPS : []
}

export const getPropertiesOfTabGroup = (properties: Property[], group: PropertyTabGroup): Property[] => (
  properties.filter((property) => group.standards.includes(property.a11y_standard))
)
